import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * 銷貨單列表。
 * 未指定 sort 時後端預設 `sales_order_no,desc`；前端可不硬送 sort。
 *
 * @param {object} listQuery
 */
export async function fetchSalesOrderList(listQuery) {
  const { data: raw } = await request.get('/crm/sales-order', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
